import { type ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * Wraps wizard step content. The parent must set `key={...}` to the same value that
 * changes when the step changes so this subtree remounts and `.wizard-step-transition`
 * runs (see `wizard-step-transition.css`, imported after Tailwind in main.tsx).
 */
export function WizardAnimatedPanel({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return <div className={cn("wizard-step-transition", className)}>{children}</div>;
}
